export const HomepageProjectDescriptionTwo = () => {
  return (
    <div className="project-description-container">
      <h2>Canvas for Works©</h2>
      <p>
        Canvas for Works© is a creative design agency that focuses on
        collaborating, in order to produce good media across multiple canvases.
        The task was to develop website visuals into a functional, responsive
        website, using React.
      </p>
    </div>
  );
};
